import angular from 'angular'
import './edit/edit.controller'
import './translation.service'

angular
  .module('pub.channel.translation', [
    'pub.channels.translation.service',
    'pub.channel.translation.edit',
  ])
  .controller('TranslationChannelCtrl', TranslationChannelCtrl)

/** @ngInject */
function TranslationChannelCtrl($rootScope, $stateParams, $timeout, TranslationChannelService) {
  $rootScope.page = 'page'
  var vm = this
  vm.items = []

  function load() {
    TranslationChannelService.listTranslations($stateParams.parentId).then(function(result) {
      vm.items = result.results
    })
  }

  load()

  vm.deleteTranslate = function(id) {
    swal(
      {
        title: 'Are you sure?',
        text: '',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function(isConfirm) {
        if (isConfirm) {
          TranslationChannelService.removeTranslation(id).then(
            function() {
              load()
            },
            function(err) {
              $timeout(function() {
                swal(err.error.message, '', 'error')
              }, 500)
            },
          )
        } else {
          return
        }
      },
    )
  }
}
